import { ResultCodeTranslation } from './result-code-translation';

export function tapResponseStatusToString(status: number) {
  return (ResultCodeTranslation as any)[status]
    ? (ResultCodeTranslation as any)[status]
    : 'Unknown tap response status';
}
